import React, { createContext, useCallback, useMemo, useRef } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';

export interface PendingAuth {
  cognitoUser: CognitoUser;
  password: string;
}

interface PendingAuthContextValue {
  get: () => PendingAuth | null;
  set: (value: PendingAuth) => void;
  clear: () => void;
}

export const PendingAuthContext = createContext<PendingAuthContextValue>({
  get: () => null,
  set: () => {},
  clear: () => {},
});

export const PendingAuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const ref = useRef<PendingAuth | null>(null);

  const get = useCallback(() => ref.current, []);
  const set = useCallback((value: PendingAuth) => {
    ref.current = value;
  }, []);
  const clear = useCallback(() => {
    ref.current = null;
  }, []);

  const value = useMemo(() => ({ get, set, clear }), [get, set, clear]);

  return (
    <PendingAuthContext.Provider value={value}>
      {children}
    </PendingAuthContext.Provider>
  );
};
